import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';

import {
  NEWSLETTER_SUBSCRIPTIONS_KEY,
  NEWSLETTER_SUBSCRIPTION_KEY,
} from '@utils/backend-api/newsletters';
import {
  NewsletterSubscriptionParams,
  subscribeToNewsletter,
} from '@utils/backend-api/newsletters';

export default function useSubscribeToNewsletter(updatedEmailSettings = false) {
  const queryClient = useQueryClient();
  const { mutate, data, isLoading, isError } = useMutation(
    async ({ newsletter_id }: NewsletterSubscriptionParams) => {
      await subscribeToNewsletter({ newsletter_id });
      queryClient.invalidateQueries([NEWSLETTER_SUBSCRIPTION_KEY, newsletter_id.toString()]);
      queryClient.invalidateQueries(NEWSLETTER_SUBSCRIPTIONS_KEY);
      if (updatedEmailSettings) {
        toast.success('Your emails settings updated sucessfully');
      }
    }
  );

  return { mutate, data, isLoading, isError };
}
